import { ObjectType } from '@convergence/types';
import { AnalysisInputProps } from '../types';
import { AnalysisInputSwitch } from './analysis-input-switch';

export function AnalysisObjectInput(props: AnalysisInputProps<ObjectType>) {
  const fields = Object.entries(props.value._fields) ?? [];

  return (
    <div className="border-l mb-">
      <div className="font-bold mb-2">{props.name}</div>
      {fields.map(([key, value]) => (
        <div className="pl-4" key={key}>
          <AnalysisInputSwitch
            name={key}
            tree={props.tree}
            onChange={props.onChange}
            value={value}
            propertyPath={[...props.propertyPath, '_fields', key]}
            errors={props.errors}
          />
        </div>
      ))}
    </div>
  );
}
